/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1ClassroomdisciplineIdChannelsChannelid202,
  PutApiV1ClassroomdisciplineIdChannelsChannelid400,
  PutApiV1ClassroomdisciplineIdChannelsChannelid401,
  PutApiV1ClassroomdisciplineIdChannelsChannelid404,
  PutApiV1ClassroomdisciplineIdChannelsChannelidMutationRequest,
  PutApiV1ClassroomdisciplineIdChannelsChannelidMutationResponse,
  PutApiV1ClassroomdisciplineIdChannelsChannelidPathParams,
} from "../../types/classPlanningChannelsController/PutApiV1ClassroomdisciplineIdChannelsChannelid.ts";
import { upsertChannelRequestViewModelSchema } from "../upsertChannelRequestViewModelSchema.ts";

export const putApiV1ClassroomdisciplineIdChannelsChannelidPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    channelId: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1ClassroomdisciplineIdChannelsChannelidPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1ClassroomdisciplineIdChannelsChannelid202Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineIdChannelsChannelid202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1ClassroomdisciplineIdChannelsChannelid400Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineIdChannelsChannelid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1ClassroomdisciplineIdChannelsChannelid401Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineIdChannelsChannelid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1ClassroomdisciplineIdChannelsChannelid404Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineIdChannelsChannelid404>;

export const putApiV1ClassroomdisciplineIdChannelsChannelidMutationRequestSchema =
  z.lazy(
    () => upsertChannelRequestViewModelSchema,
  ) as unknown as ToZod<PutApiV1ClassroomdisciplineIdChannelsChannelidMutationRequest>;

export const putApiV1ClassroomdisciplineIdChannelsChannelidMutationResponseSchema =
  z.lazy(
    () => putApiV1ClassroomdisciplineIdChannelsChannelid202Schema,
  ) as unknown as ToZod<PutApiV1ClassroomdisciplineIdChannelsChannelidMutationResponse>;
